import React, { useState, useEffect, useRef } from "react";
import HttpClient from "../../utils/HttpClient";
import { useLanguage } from "../../Providers/LanguageContext";
import Select from 'react-select';
import './MilestonePopUp.css';
import toast from "react-hot-toast";

function DeviationPopup({ closeModal }) {
    const { language } = useLanguage();
    const [formData, setFormData] = useState({
        projectId: "",
        budgetType: "",
        budget: 1,
        durationType: "",
        duration: 0,
        durationUnit: "days",
        status: "risk",
        notes: "",
        phaseId: [],
    });
    const [phases, setPhases] = useState([]);
    const [selectedPhaseId, setSelectedPhaseId] = useState('');
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // Fetch projects and Tasks when component mounts
    useEffect(() => {
        fetchProjects();
    }, []);

    const fetchProjects = async () => {
        const res = await HttpClient.requestData("view-all-project", "GET", {});
        if (res && res.status) {
            setProjects(res.data);
        } else {
            setProjects([]);
        }
    };

    const getExistingPhases = async projectId => {
        try {
            const res = await HttpClient.requestData(`phases/${projectId}`, 'GET');
            if (res && res.data) {

                setPhases(res?.data);
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to load existing phases');
            setPhases([]);
        }
    };

    useEffect(() => {
        if (formData?.projectId) {
            getExistingPhases(formData?.projectId);
        }
    }, [formData?.projectId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            let payload = null;

            if (selectedPhaseId?.length) {
                payload = {
                    ...formData,
                    budget: +formData?.budget || 1,
                    phaseId: [selectedPhaseId],
                    duration: formData?.duration || 0,
                    durationUnit: formData?.durationUnit || 'days',
                }
            } else {
                payload = {
                    ...formData,
                    budget: +formData?.budget || 1,
                    phaseId: [],
                    duration: formData?.duration || 0,
                    durationUnit: formData?.durationUnit || 'days',
                }
            }

            console.log("payload during submit: ", payload);


            const res = await HttpClient.requestData("createprojectdeviation", "POST", payload);
            if (res && res.status) {
                // console.log('res: ', res);

                if (res?.message === "The project budget has been successfully updated. All related phase and milestone amounts have been adjusted accordingly to ensure they remain consistent with the overall budget." || res?.message === "The project budget has been successfully updated. All related  milestone amounts have been adjusted accordingly to ensure they remain consistent with the overall budget.") {
                    toast.error(res?.message || 'something went wrong!!!');
                    setTimeout(() => {
                        closeModal();
                    }, 1000);
                    return;
                }
                toast.success(res?.message || "Project Deviation Added Successfully");
                setTimeout(() => {
                    closeModal();
                }, 1000);

                // Reset the form ....
                setFormData({
                    projectId: "",
                    budgetType: "",
                    budget: 1,
                    durationType: "",
                    duration: 0,
                    durationUnit: "",
                    status: "risk",
                    notes: "",
                    phaseId: [],
                });
            } else {
                console.log("res in else: ", res);

                toast.error(res?.error ? res?.error : res?.message);
            }
        } catch (error) {
            console.error("Error creating milestone:", error);
            toast.error(error?.error ? error?.error : error?.message);
        } finally {
            setIsLoading(false);
        }
    };


    console.log("formData: ", formData);
    // console.log('selectedTasks: ', selectedTasks);
    const modalRef = useRef();

    useEffect(() => {
        const OustideClickClose = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                closeModal(false)
            }
        }
        document.addEventListener('mousedown', OustideClickClose)
    }, [])


    return (
        <div className="modal-overlay" >
            <div ref={modalRef} className="modal-content">
                <div className="modal-header">
                    <h3>{language.Add_Project_Deviation}</h3>
                    <button onClick={() => closeModal(false)} className="close-btn">×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>{language.Select_Project}</label>
                        <select
                            name="projectId"
                            value={formData.projectId}
                            onChange={handleChange}
                            required
                        >
                            <option value="">{language.select_project}</option>
                            {projects.map(project => (
                                <option key={project._id} value={project._id}>
                                    {project.projectName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>{language.Budget_Change}</label>
                        {/* <input
                            type="number"
                            name="toBeIncreasedBudget"
                            value={formData.toBeIncreasedBudget}
                            onChange={handleChange}
                            placeholder={language.To_Be_Increased_Budget}
                            required
                            min="0"  // This prevents negative numbers
                        /> */}
                        <select name="budgetType" onChange={handleChange} >
                            <option value={''}>{language.select_budget_type}</option>
                            <option value={'increase'}>Increase</option>
                            <option value={'decrease'}>Decrease</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>{language.Budget_Value}</label>
                        <input
                            type="number"
                            name="budget"
                            value={formData.budget}
                            onChange={handleChange}
                            placeholder={language.Budget_Value}
                            required
                            min="1"  // This prevents negative numbers
                        />
                    </div>

                    <div className="form-group">
                        <label>{language.To_Be_Increased_Duration}</label>
                        <select name="durationType" onChange={handleChange}>
                            <option value={''}>{language.duration_type}</option>
                            <option value={'increase'}>Increase</option>
                            <option value={'decrease'}>Decrease</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>{language.duration_value}</label>
                        <div className="form-group22">
                            <input
                                type="number"
                                name="duration"
                                value={formData.duration}
                                onChange={handleChange}
                                placeholder={language.duration_value}
                                required
                                min="0"
                            />
                            <select
                                name="durationUnit"
                                onChange={handleChange}
                            >
                                <option value={''}>{language.duration_unit}</option>
                                <option value={'hours'}>Hours</option>
                                <option value={'days'}>Days</option>
                                <option value={'weeks'}>Weeks</option>
                                <option value={'months'}>Months</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>{language.Select_Phase}</label>
                        <select onChange={e => setSelectedPhaseId(e.target.value)}>
                            <option value={''}>{language.Select_Phase}</option>
                            {
                                phases?.length > 0 ? phases?.map((phase, i) => (
                                    <option value={phase?._id}>{phase && phase?.name}</option>
                                )) : (<option value={''}>No phase available ....</option>)
                            }
                        </select>
                    </div>

                    <div className="form-group">
                        <label>{language.Notes}</label>
                        <input
                            type="text"
                            name="notes"
                            value={formData.notes}
                            onChange={handleChange}
                            placeholder={language.Notes}
                            required
                        />
                    </div>

                    <div className="modal-footer">
                        <button type="button" onClick={() => closeModal(false)} className="cancel-btn">
                            {language.cancel}
                        </button>
                        <button type="submit" className="submit-btn" disabled={isLoading}>
                            {isLoading ? language.creating : language.CREATE}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default DeviationPopup;